export class TableException extends Error {
    id: number = 0;
    constructor(message: string, id: number = 0) {
        super(message);
        this.id = id;
        this.name = "TableException";
    }
}